import * as React from "react";
import Svg, { Defs, Path, G, Mask, Use } from "react-native-svg";

function CalendarIcon(props) {
  const color = props.color || "#707070";
  return (
    <Svg
      width={props.width || 40}
      height={props.height || 40}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <Defs>
        <Path id="Calend1" d="M0 0H29V29H0z" />
      </Defs>
      <G
        transform="translate(5 6)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <Mask id="Calend2" fill="#fff">
          <Use xlinkHref="#Calend1" />
        </Mask>
        <G mask="url(#Calend2)">
          <G transform="translate(-.003 -.003)">
            <Path
              stroke="none"
              fill="none"
              d="M0.00308998349 0.00308998349H29.00308998349V29.00308998349H0.00308998349z"
            />
            <Path
              d="M.628 5.066v23h27v-23h-27zm22.938-1.438h3.625a1.713 1.713 0 011.812 1.813v21.75a1.713 1.713 0 01-1.812 1.812H1.816a1.713 1.713 0 01-1.813-1.812V5.44a1.713 1.713 0 011.813-1.813H5.44V1.816A1.713 1.713 0 017.253.003a1.713 1.713 0 011.813 1.813v1.812H19.94V1.816a1.813 1.813 0 013.625 0v1.812z"
              stroke="none"
              fill={color}
              fillRule="evenodd"
            />
            <Path
              stroke={color}
              strokeWidth={1}
              fill="none"
              d="M13.00309 12.00309H16.00309V15.00309H13.00309z"
            />
            <Path
              stroke={color}
              strokeWidth={1}
              fill="none"
              d="M13.00309 19.00309H16.00309V22.00309H13.00309z"
            />
            <Path
              stroke={color}
              strokeWidth={1}
              fill="none"
              d="M8.00308998 19.00309H11.00308998V22.00309H8.00308998z"
            />
            <Path
              stroke={color}
              strokeWidth={1}
              fill="none"
              d="M18.00309 19.00309H21.00309V22.00309H18.00309z"
            />
            <Path
              stroke={color}
              strokeWidth={1}
              fill="none"
              d="M18.00309 12.00309H21.00309V15.00309H18.00309z"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}

export default CalendarIcon;
